import { useState } from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { contact } from "../data/siteConfig";
import { CallSheet } from "./CallSheet";

export const MobileBookBar = () => {
    const [callOpen, setCallOpen] = useState(false);
    const showCall = !contact.landline.pending || !contact.mobile.pending;

    return (
        <>
            <div
                className="fixed inset-x-0 bottom-0 z-50 border-t border-stone-200 bg-cream/92 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2 backdrop-blur-xl md:hidden"
                data-testid="mobile-book-bar"
            >
                <div className="flex items-stretch gap-2 px-3">
                    {showCall && (
                        <button
                            onClick={() => setCallOpen(true)}
                            className="flex flex-1 flex-col items-center justify-center gap-1 rounded-xl py-3 text-stone-600 transition-colors duration-200 hover:text-[#1c1917]"
                            data-testid="mobilebar-call"
                            aria-label="Call the cattery"
                        >
                            <Phone className="h-5 w-5" />
                            <span className="text-xs font-medium">Call</span>
                        </button>
                    )}
                    <a
                        href="#book"
                        className="flex flex-[1.6] flex-col items-center justify-center gap-0.5 rounded-xl bg-[#1c1917] py-3 text-cream shadow-md shadow-black/15"
                        data-testid="mobilebar-book"
                        aria-label="Request a booking"
                    >
                        <CalendarCheck className="h-5 w-5" />
                        <span className="text-xs font-bold tracking-wide">Book</span>
                    </a>
                </div>
            </div>
            <CallSheet open={callOpen} onClose={() => setCallOpen(false)} />
        </>
    );
};
